<template>
  <div class="ta-auction-viewing-dates" v-if="auction.private_viewing_start_date && auction.private_viewing_end_date">
    <b v-if="label" class="ta-auction-viewing-dates-label">{{ label }}: </b>
    <span class="ta-auction-viewing-dates-value">{{ privateViewingDates }}</span>
  </div>
</template>

<script>

import auctionViewMixin from "@/mixins/auctionViewMixin";

export default {
  name: "AuctionPrivateViewingDates",
  mixins: [auctionViewMixin],
  props: {
    label: {
      type: [Boolean, String],
      default() {
        return this.$t('Private Viewing Dates')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
